module.exports = __webpack_public_path__ + "static/media/shutterstock_524208406.14d409c8.jpg";